import { Component, OnInit } from '@angular/core';
import { OAuthService } from '../../../core/services/oauth.service';
import { NotificationService } from '../../../core/services/notification.service';
import { AuthProvider } from '../../models/integrations.model';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-auth-oauth2-modal',
  templateUrl: './auth-oauth2-modal.component.html',
  styleUrls: ['./auth-oauth2-modal.component.less']
})
export class AuthOauth2ModalComponent implements OnInit {
  dataSourceProvider: AuthProvider | null = null;

  constructor(
    private modalRef: NzModalRef,
    private oauthService: OAuthService,
    private notificationService: NotificationService
  ) {
    // Obtener parámetros del modal
    this.dataSourceProvider = this.modalRef.getConfig().nzData?.dataSourceProvider;
  }

  ngOnInit(): void {
    // Automáticamente redirigir cuando se abre el modal
    if (this.dataSourceProvider) {
      this.handleOAuth2Redirect();
    }
  }

  handleOAuth2Redirect(): void {
    if (!this.dataSourceProvider) return;

    this.oauthService.connect(this.dataSourceProvider.id).subscribe({
      next: (response) => {
        if (response.authorizationUrl) {
          // Redirigir a la URL de autorización OAuth2
          window.location.href = response.authorizationUrl;
        } else {
          this.notificationService.error('Error de configuración', 'No se recibió la URL de autorización del servidor');
          this.modalRef.close();
        }
      },
      error: (error) => {
        console.error('Error obteniendo URL de autorización:', error);
        this.notificationService.error('Error de OAuth', 'No se pudo obtener la URL de autorización');
        this.modalRef.close();
      }
    });
  }

  get dataSourceProviderName(): string {
    return this.dataSourceProvider?.name || 'el proveedor de datos';
  }
}

